const TONE_CLASS = {
  primary: "admin-action-group--primary",
  maintenance: "admin-action-group--maintenance",
  danger: "admin-action-group--danger",
  default: "",
};

export default function AdminActionGroup({
  label,
  tone = "default",
  className = "",
  children,
}) {
  const toneClass = TONE_CLASS[tone] || TONE_CLASS.default;

  return (
    <div
      className={`admin-action-group ${toneClass}${className ? ` ${className}` : ""}`}
      role="group"
      aria-label={label || undefined}
    >
      {label ? <span className="admin-action-group__label eyebrow">{label}</span> : null}
      <div className="admin-action-group__buttons">{children}</div>
    </div>
  );
}
